// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_20-6";
export var headerCell = "_20-2";
export var rowWrapper = "_20-4";
export var stickyAggregationCell = "_20-a";
export var stickyAggregationRow = "_20-7";
export var stickyColumnCell = "_20-9";
export var stickyColumnHeaderCell = "_20-8";
export var table = "_20-1";
export var virtualRowWrapper = "_20-5";
export var virtualTableContainer = "_20-0";
export var white = "_20-3";